import {ATLAS_TMM_DB, REALTIME_DB} from '@/config/firebase';
import {push, ref, remove} from 'firebase/database';

export const allWatchList = (airline: string) => {
  return ref(REALTIME_DB, `${airline}/${ATLAS_TMM_DB}/watch_list`);
};

export const addToWatchList = async (airline: string, val: string) => {
  const item = ref(REALTIME_DB, `${airline}/${ATLAS_TMM_DB}/watch_list`);
  void push(item, val);
};

export const removeFromWatchList = async (airline: string, key: string) => {
  const item = ref(REALTIME_DB, `${airline}/${ATLAS_TMM_DB}/watch_list/${key}`);
  void remove(item);
};
